export interface AnnotationLabel {
  display: boolean;
  content?: string;
  position?: string;
  backgroundColor?: string;
  color?: string;
  font?: { weight: string; size: number };
}

export interface AnnotationItem {
  type: string;
  yMin: number;
  yMax: number;
  borderColor: string;
  borderWidth: number;
  borderDash: number[];
  label: AnnotationLabel;
}

export const annotationData = (querySpecies: string) => {
  if (querySpecies === "PM10") {
    return {
      low2: {
        type: "line",
        yMin: 17,
        yMax: 17,
        // borderColor: '#689F38',
        borderColor: "#388E3C",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      low3: {
        type: "line",
        yMin: 34,
        yMax: 34,
        borderColor: "#388E3C",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      mod1: {
        type: "line",
        yMin: 51,
        yMax: 51,
        // borderColor: '#FFECB3',
        borderColor: "#FF9800",
        borderWidth: 1,
        borderDash: [6, 6],
        label: {
          display: true,
          content: "Moderate",
          position: "end",
          // backgroundColor: '#FFECB3',
          backgroundColor: "#FF9800",
          color: "#fff",
          font: { weight: "bold", size: 14 },
        },
      },
      mod2: {
        type: "line",
        yMin: 59,
        yMax: 59,
        // borderColor: '#FFB74D',
        borderColor: "#FF9800",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      mod3: {
        type: "line",
        yMin: 67,
        yMax: 67,
        borderColor: "#FF9800",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      high1: {
        type: "line",
        yMin: 76,
        yMax: 76,
        // borderColor: '#E57373',
        borderColor: "#FF0000",
        borderWidth: 1,
        borderDash: [6, 6],
        label: {
          display: true,
          content: "High",
          position: "end",
          backgroundColor: "#FF0000",
          color: "#fff",
          font: { weight: "bold", size: 14 },
        },
      },
      high2: {
        type: "line",
        yMin: 84,
        yMax: 84,
        // borderColor: '#D32F2F',
        borderColor: "#FF0000",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      high3: {
        type: "line",
        yMin: 92,
        yMax: 92,
        // borderColor: '#B71C1C',
        borderColor: "#FF0000",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      veryHigh: {
        type: "line",
        yMin: 101,
        yMax: 101,
        borderColor: "#000000",
        borderWidth: 1,
        borderDash: [6, 6],
        label: {
          display: true,
          content: "Very High",
          position: "end",
          backgroundColor: "#000000",
          color: "#fff",
          font: { weight: "bold", size: 14 },
        },
      },
    };
  } else if (querySpecies === "PM25") {
    return {
      low2: {
        type: "line",
        yMin: 12,
        yMax: 12,
        // borderColor: '#689F38',
        borderColor: "#388E3C",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      low3: {
        type: "line",
        yMin: 24,
        yMax: 24,
        borderColor: "#388E3C",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      mod1: {
        type: "line",
        yMin: 36,
        yMax: 36,
        // borderColor: '#FFECB3',
        borderColor: "#FF9800",
        borderWidth: 1,
        borderDash: [6, 6],
        label: {
          display: true,
          content: "Moderate",
          position: "end",
          // backgroundColor: '#FFECB3',
          backgroundColor: "#FF9800",
          color: "#fff",
          font: { weight: "bold", size: 14 },
        },
      },
      mod2: {
        type: "line",
        yMin: 42,
        yMax: 42,
        // borderColor: '#FFB74D',
        borderColor: "#FF9800",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      mod3: {
        type: "line",
        yMin: 47,
        yMax: 47,
        borderColor: "#FF9800",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      high1: {
        type: "line",
        yMin: 54,
        yMax: 54,
        // borderColor: '#E57373',
        borderColor: "#FF0000",
        borderWidth: 1,
        borderDash: [6, 6],
        label: {
          display: true,
          content: "High",
          position: "end",
          backgroundColor: "#FF0000",
          color: "#fff",
          font: { weight: "bold", size: 14 },
        },
      },
      high2: {
        type: "line",
        yMin: 59,
        yMax: 59,
        // borderColor: '#D32F2F',
        borderColor: "#FF0000",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      high3: {
        type: "line",
        yMin: 65,
        yMax: 65,
        // borderColor: '#B71C1C',
        borderColor: "#FF0000",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      veryHigh: {
        type: "line",
        yMin: 71,
        yMax: 71,
        borderColor: "#000000",
        borderWidth: 1,
        borderDash: [6, 6],
        label: {
          display: true,
          content: "Very High",
          position: "end",
          backgroundColor: "#000000",
          color: "#fff",
          font: { weight: "bold", size: 14 },
        },
      },
    };
  } else if (querySpecies === "NO2") {
    return {
      low2: {
        type: "line",
        yMin: 67,
        yMax: 67,
        // borderColor: '#689F38',
        borderColor: "#388E3C",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      low3: {
        type: "line",
        yMin: 134,
        yMax: 134,
        borderColor: "#388E3C",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      mod1: {
        type: "line",
        yMin: 201,
        yMax: 201,
        // borderColor: '#FFECB3',
        borderColor: "#FF9800",
        borderWidth: 1,
        borderDash: [6, 6],
        label: {
          display: true,
          content: "Moderate",
          position: "end",
          // backgroundColor: '#FFECB3',
          backgroundColor: "#FF9800",
          color: "#fff",
          font: { weight: "bold", size: 14 },
        },
      },
      mod2: {
        type: "line",
        yMin: 268,
        yMax: 268,
        // borderColor: '#FFB74D',
        borderColor: "#FF9800",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      mod3: {
        type: "line",
        yMin: 335,
        yMax: 335,
        borderColor: "#FF9800",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      high1: {
        type: "line",
        yMin: 401,
        yMax: 401,
        // borderColor: '#E57373',
        borderColor: "#FF0000",
        borderWidth: 1,
        borderDash: [6, 6],
        label: {
          display: true,
          content: "High",
          position: "end",
          backgroundColor: "#FF0000",
          color: "#fff",
          font: { weight: "bold", size: 14 },
        },
      },
      high2: {
        type: "line",
        yMin: 468,
        yMax: 468,
        // borderColor: '#D32F2F',
        borderColor: "#FF0000",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      high3: {
        type: "line",
        yMin: 535,
        yMax: 535,
        // borderColor: '#B71C1C',
        borderColor: "#FF0000",
        borderWidth: 1,
        borderDash: [6, 6],
        label: { display: false },
      },
      veryHigh: {
        type: "line",
        yMin: 601,
        yMax: 601,
        borderColor: "#000000",
        borderWidth: 1,
        borderDash: [6, 6],
        label: {
          display: true,
          content: "Very High",
          position: "end",
          backgroundColor: "#000000",
          color: "#fff",
          font: { weight: "bold", size: 14 },
        },
      },
    };
  } else {
    return {};
  }
};
